import { render, staticRenderFns } from "./top-color.vue?vue&type=template&id=06f38b79&"
import script from "./top-color.vue?vue&type=script&lang=js&"
export * from "./top-color.vue?vue&type=script&lang=js&"
import style0 from "./top-color.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports